<div class="table-responsive table-hover table-block">

  <table class="table bg-white">
    <thead class="bg-header-table">
      <tr>
        <th i18n class="text-left">Usuários</th>
        <th i18n class="text-center">Permissões</th>
        <th i18n class="text-right">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of users">
        <td (click)="openDetail(user)">
          <div class="content d-flex align-items-center ">
            <app-avatar
              [user]="user"
              class="avatar-userGroup-list"></app-avatar>
            <div class="text pl-3">
              <p class="mb-0"><strong>{{ user.name }}</strong></p>
              <p class="mb-0">{{ user.email }}</p>
            </div>
          </div>
        </td>
        <td class="d-flex justify-content-center align-items-center"
          (click)="openDetail(user)">
          <div class="content">
            <div
              *ngFor="let permission of user.UserAdminPermissions | slice:0:5"
              class="badge badge-fade-primary mr-1">
              <span>{{permissionI18n[permission.AdminPermission.name]}}</span>
            </div>
            <div
              *ngIf="user.UserAdminPermissions.length > 5"
              class="badge badge-primary mr-1"
              (click)="openDetail(user)">
              + {{ user.UserAdminPermissions.length - 5}}</div>
          </div>
        </td>
        <td class="text-right">
          <button
            type="button"
            class="btn text-secondary btn-icon-block"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            <i class="material-icons">more_horiz</i>
          </button>
          <div
            class="dropdown-menu"
            aria-labelledby="btnGroupDrop4">
            <a
              class="dropdown-item"
              (click)="openEditPermissions(user)" i18n>
              Editar Permissões
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
